import { useState } from 'react';
import { Button } from '@atoms/Button';
import { usePwaInstall } from '@/hooks/usePwaInstall';

export function InstallBanner() {
  const { canInstall, promptInstall } = usePwaInstall();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('pwa-install-dismissed') === '1',
  );

  if (!canInstall || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem('pwa-install-dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="border-b border-brand-200 bg-brand-50 px-4 py-2">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2 text-sm text-brand-900">
        <span>Uygulamayı ana ekrana ekleyerek daha hızlı erişin.</span>
        <div className="flex gap-2">
          <Button size="sm" onClick={() => void promptInstall()}>
            Yükle
          </Button>
          <Button size="sm" variant="ghost" onClick={dismiss}>
            Kapat
          </Button>
        </div>
      </div>
    </div>
  );
}
